import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { getTaux } from '../../data/tarifsData';
import './Formations.css';

const DEVISES = [
  { key: 'fcfa', label: 'FCFA' },
  { key: 'usd',  label: 'USD'  },
  { key: 'eur',  label: 'EUR'  },
];

function fmt(fcfa, devise, TAUX) {
  if (!fcfa) return 'Sur devis';
  if (devise === 'usd') return Math.round(fcfa / TAUX.USD).toLocaleString('fr-FR') + ' $';
  if (devise === 'eur') return Math.round(fcfa / TAUX.EUR).toLocaleString('fr-FR') + ' €';
  return Math.round(fcfa).toLocaleString('fr-FR') + ' FCFA';
}

export function Formations() {
  const { data } = useApp();
  const [devise, setDevise] = useState('fcfa');
  const TAUX = getTaux(data.tauxChange || {});

  return (
    <section className="ms bg2" id="formations">
      <div className="sh">
        <div className="stag">Formations Certifiantes</div>
        <h2 className="stitle">Montez en Compétences<br />avec Nos Experts</h2>
        <p className="sdesc">Formations pratiques et certifiantes. Obtenez votre certificat KOTOSTECHNOLOGY.</p>

        {/* Sélecteur devise */}
        <div className="dig-devise-btns" style={{ marginTop: '18px' }}>
          {DEVISES.map(d => (
            <button
              key={d.key}
              className={`dig-devise-btn ${devise === d.key ? 'active' : ''}`}
              onClick={() => setDevise(d.key)}
            >
              {d.label}
            </button>
          ))}
        </div>
      </div>
      <div className="fgrid">
        {data.formations.map((f, i) => (
          <div key={f.id} className="fc" style={{ animationDelay: `${i * 0.07}s` }}>
            <div className="fc-head">
              <div className="cert-b">CERTIFIANT</div>
              <div className="fc-icon">{f.icon}</div>
              <div className="fc-title">{f.title}</div>
              <div className="fc-meta">
                <span className="fmeta">⏱️ {f.duree}</span>
                <span className="fmeta">👥 {f.places}</span>
                <span className="fmeta">📍 {f.mode}</span>
              </div>
            </div>
            <div className="fc-body">
              <ul className="fmods">
                {f.modules.map((m, j) => <li key={j}>{m}</li>)}
              </ul>
              <div className="fc-price">
                <div className="fp">
                  {f.fcfa != null ? fmt(f.fcfa, devise, TAUX) : `${f.price} ${f.currency}`}
                </div>
                <a href="#contact" className="bsm bsm-blue">S'inscrire →</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export function Immobilier() {
  const { data } = useApp();
  return (
    <section className="ms bg3" id="immobilier">
      <div className="sh">
        <div className="stag">Immobilier</div>
        <h2 className="stitle">Votre Patrimoine,<br />Notre Priorité</h2>
        <p className="sdesc">Achat, vente, location et recouvrement de loyers au Bénin.</p>
      </div>
      <div className="igrid">
        {data.immo.map(im => (
          <div key={im.id} className="ic">
            <div className="ic-head">
              <span style={{ fontSize: 30 }}>{im.icon}</span>
              <div>
                <div className="ic-title">{im.title}</div>
                <div className="ic-sub">{im.sub}</div>
              </div>
            </div>
            <div className="ic-body">
              {im.items.map((it, j) => (
                <div key={j} className="ii">
                  <div className="ii-icon">{it.icon}</div>
                  <div>
                    <h4>{it.title}</h4>
                    <p>{it.desc}</p>
                    {it.price && <div className="ip">{it.price}</div>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export function Documents() {
  const { data } = useApp();
  const typeIcon = { pdf:'📄',doc:'📝',docx:'📝',xls:'📊',xlsx:'📊',png:'🖼️',jpg:'🖼️',jpeg:'🖼️' };
  return (
    <section className="ms" id="documents">
      <div className="sh">
        <div className="stag">Documents</div>
        <h2 className="stitle">Documents Téléchargeables</h2>
        <p className="sdesc">Brochures, fiches techniques et guides disponibles sur <strong>www.kotostechnology.com</strong></p>
      </div>
      {(data.docs||[]).length === 0 ? (
        <div className="no-docs">📂 Aucun document disponible.<br /><span>Ajoutez des documents depuis Administration.</span></div>
      ) : (
        <div className="docs-grid">
          {(data.docs||[]).map((doc, i) => {
            const ext = doc.name.split('.').pop().toLowerCase();
            return (
              <div key={i} className="doc-card">
                <div className="doc-type">{typeIcon[ext] || '📁'}</div>
                <div className="doc-name">{doc.name}</div>
                {doc.domain && <div className="doc-domain">{doc.domain}</div>}
                <div className="doc-size">{doc.size}</div>
                <a className="btn-dl" href={doc.data} download={doc.name}>⬇ Télécharger</a>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}